<div class="toast-container" *ngIf="toastState == 'show' || toastState == 'visible'">
  <div class="toast-content" [attr.data-name]="toastData?.name"
    [style.visibility]="toastState == 'show' ? 'visible' : 'hidden'" [@toast]="toastState" [ngClass]="{
         'successStatus': toastData?.successStatus,
         'failStatus': toastData?.failStatus
       }" (@toast.done)="animationDone($event)">

    <div class="toast-message" *ngIf="!toastData?.messageData">
      {{ toastData?.message | translate }}
    </div>

    <div class="toast-message" *ngIf="toastData?.messageData">
      {{ toastData?.message | translate: toastData.messageData }}
    </div>

    <i class="icon-times" (click)="closeToast()"></i>
  </div>
</div>
